import { gql } from 'apollo-boost';
import { useQueryRefresh, removeConnectionsMemoized } from 'shared/apollo';

export const donorsQuery = gql`
  {
    allDonors {
      edges {
        node {
          dbId
          name
          adminEmail
        }
      }
    }
  }
`;

export function useDonorsQuery() {
  const { data: query, refresh, isLoading } = useQueryRefresh(donorsQuery);
  const data = removeConnectionsMemoized(query?.allDonors);
  return { data: data||[], refresh, isLoading };
}

const portfoliosQuery = gql`
  query PortfoliosQuery($accountIdIn: [Int!]) {
    allPortfolios(filters: {
      accountIdIn: $accountIdIn
    }) {
      edges {
        node {
          dbId
          name
          accountId
        }
      }
    }
  }
`;

export function usePorfoliosQuery(accountIdIn) {
  const skipQuery = !accountIdIn || accountIdIn.length === 0;
  const { data: query, refresh, isLoading } = useQueryRefresh(portfoliosQuery, { accountIdIn }, [], true, skipQuery);
  const data = skipQuery ? [] : removeConnectionsMemoized(query?.allPortfolios);
  return { data: data || [], refresh, isLoading };
}

